import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'paginate' })
export class PaginationPipe implements PipeTransform {
  transform(items: any[], pageSize: number, pageNumber: number): any[] {
    if (!items || !pageSize) {
      return items;
    }

    const start = pageNumber * pageSize;
    return items.slice(start, start + pageSize);
  }
}
